import React from 'react';
import Item from './Item'

class Multiselect extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			className: this._className(),
			value: props.value || [],
			items: this._getOptions(props.items) || [],
			originalValue: []
		};

		// Original value are the values that were pre-set: a clone of the values array
		this.state.originalValue = this.state.value.slice(0);
	}

	// Public API
	setValue = (value) => {
		//this._update(value, this._parse(value), this._format(value));
	}

	getValue = () => {
		return this.state.value;
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return this.props.required && !this.props.value.length > 0 ? false : true;
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_getOptions = (items) => {
		// It's an array coming, return that one..
		if (items instanceof Array)
			return items;

		let options = [];

		for (var c in items)
			options.push({
				value: c,
				label: items[c]
			});

		return options;
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_handleChange = (id, selected) => {
		let selectedValues = this.state.value;
		const me = this;

		// Selected
		if (selected && !selectedValues.includes(id)) {
			selectedValues.push(id);
		}
		// Deselected
		else if (!selected && selectedValues.includes(id)) {
			var idx = selectedValues.indexOf(id);

			if (idx !== -1) {
				selectedValues.splice(idx, 1)
			}
		}

		this.setState({ value: selectedValues }, function () {
			this.forceUpdate();

			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(selectedValues, this.props.name, function () { me.onChange(selectedValues); });
			else
				// If not, only trigger this comp change
				this.onChange(selectedValues);
		});
	}

	_sortedList = () => {
		const selection = this.state.originalValue;

		const selectedList = this.state.items.filter(function (i) { return selection.includes(i.value) }).sort((a, b) => {
			if (a.label < b.label)
				return -1;
			if (a.label > b.label)
				return 1;
			return 0;
		});

		const nonSelectedList = this.state.items.filter(function (i) { return !selection.includes(i.value) }).sort((a, b) => {
			if (a.label < b.label)
				return -1;
			if (a.label > b.label)
				return 1;
			return 0;
		});

		return selectedList.concat(nonSelectedList);
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.state.value
			|| nextState.value !== this.state.value
			|| nextProps.items !== this.props.items
			|| nextProps.disabled !== this.props.disabled
			|| nextState.className !== this.state.className);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.items !== null && nextProps.items !== undefined) {
			this.setState((prevState, prevProps) => {
				// Only update original value if it isnt already set or if the value lists references are non equals
				let shouldUpdate = prevState.originalValue === null || prevState.value !== nextProps.value;

				return {
					value: nextProps.value || [],
					items: this._getOptions(nextProps.items),
					originalValue: shouldUpdate ? JSON.parse(JSON.stringify(nextProps.value)) : prevState.originalValue
				}
			});
		}
	}

	render() {
		const defaultHeight = "200px";
		const containerStyle = { height: this.props.height || defaultHeight };
		const self = this;

		return (
			<div className="multiselect" name={this.props.name} style={containerStyle}>
				{
					this._sortedList().map(function (item) {
						return (<Item
							key={item.value}
							text={item.label}
							id={item.value}
							selected={self.state.value.includes(item.value)}
							disabled={self.props.disabled}
							onChange={self._handleChange} />)
					})
				}
			</div >)
	}
}

Multiselect.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false
};

export default Multiselect;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/multiselect/Multiselect.js